import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../services/global';
import { BaseCrudComponent } from '../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';
import { Observable, BehaviorSubject, of, throwError, from } from 'rxjs';
import { mergeMap, catchError, timeout, retry } from 'rxjs/operators';
import { ExportAsService, ExportAsConfig } from 'ngx-export-as';
import * as moment from 'moment-timezone';

import { LazyLoadEvent } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import {MessageService} from 'primeng/api';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-salesbyclientcategory',
  templateUrl: './salesbyclientcategory.component.html',
  styleUrls: ['./salesbyclientcategory.component.css']
})
export class SalesbyclientcategoryComponent extends BaseCrudComponent {

    exportAsConfig: ExportAsConfig = {
        type: 'xlsx',
        elementIdOrContent: 'exportable'
    };

  	translations:any;
	header:any;
	theaders:any;
	momentjs: any = moment;
    curr_date:any;
    today:any;
    dstart:any;
    dend:any;
    zones:any;
    totals:any;
    totalsCat:any;
    cats:any;
    catcount:any;
    innercats:any;
    kpis:any;
    frozenCols:any;

	constructor(
	    srv: ApiService,
	    modalService: NgbModal,
	    storage: Storage,
  		router: Router,
  		private route: ActivatedRoute,
        public translate: TranslateService,
        private exportAsService: ExportAsService
	  ) {
	    super(srv, modalService, storage, router);
	    this.read_url = 'ReportSalesPerClientPerCategory/Post';
        this.header = {};
        this.theaders = [
           // {label:'CLIENTE', key:'nombreCliente'},
            {label:'COD', key:'idCliente', sortfield:'idCliente'},

            {label:'CIUDAD', key:'ciudad', sortfield:'ciudad'},

            {label:'ABC', key:'abc', sortfield:'abc'},
            {label:'TIPOLOGIA', key:'tipologia', sortfield:'tipologia'},

            {label:'CUPO', key:'cupo', sortfield:'cupo'},
            {label:'CUPO DISPONIBLE', key:'cupoDisponible', sortfield:'cupoDisponible'},
            {label:'STATUS CR', key:'status', sortfield:'status'},
            {label:'F_ULTVTA', key:'fechaUltVenta', sortfield:'fechaUltVenta'},

            {label:'VTA NETA REAL', key:'ventaTotal', sortfield:'sort_ventaTotal'},
            {label:'VTA PROM MES AÑO X-1', key:'ventaTotalAnterior', sortfield:'sort_ventaTotalAnterior'},
            {label:'$ VAR', key:'variacionTotal', sortfield:'sort_variacionTotal'},
            {label:'% VAR', key:'porcenVariacionTotal', sortfield:'sort_porcenVariacionTotal'},

            {label:'DEVOLUCION', key:'devolucion', sortfield:'devolucion'},
            {label:'%DEV / VTA NETA', key:'promedioDevolucion', sortfield:'promedioDevolucion'}

        ];
        this.zones = [];
        this.rows = [];
        this.totals = [];
        this.totalsCat = [];
        this.cats = [];
        this.catcount = [];
        this.innercats = [];
        this.kpis = {};
        this.frozenCols = [
            { field: 'nombreCliente', header: 'CLIENTE', sortable:true, sortfield:'nombreCliente', styleC:{'text-align':'center'}, width:{'width.px': 350}, isColor:false, pre:'', pos:'', total:''}
        ];
    }

    ngOnInit() {
        /*this.curr_date = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.today = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.f_datefrom = this.curr_date;*/
        this.curr_date = this.momentjs().tz('America/Guayaquil').format('YYYY-MM');
        this.today = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.f_datefrom = this.curr_date;

    	this.translate.getTranslation(this.translate.currentLang)
        .subscribe((translations) => {
              this.translations = translations;
              super.ngOnInit();
              this.getList();
        });

        this.getZonesData().subscribe(x => {
            if(x != false){
                this.zones = x;
            }
        });
    }

    clearData(){
        this.header = {};
        this.rows = [];
        this.totals = [];
        this.cats = [];
        this.catcount = [];
        this.innercats = [];
        this.kpis = {};
    }

    public getList(){
        var qst = this.read_url;
        var obj:any;
        //this.f_datefrom = '2020-09-01';
        this.clearData();

        obj = {
            Zone: null,
            //Date: this.f_datefrom
            Date: this.f_datefrom + '-01'
        }

        if( (this.f_custom1 != null) && (this.f_custom1 != 'null') ){
        	obj.Zone = this.f_custom1;
        }

        this.loadingList = true;
        //console.log(obj);

        this.srv.postCall(qst, obj).subscribe(x => {
        	this.loadingList = false;

            if(x.status){
                var rs = x.data;
                this.header = rs.header;
                this.rows = rs.detail.detail;
                this.totals = rs.totals;
                this.totalsCat = rs.totalsByCategories;
                this.kpis = rs.salesPerClientPerCategoryKPIs;
                this.cats = this.getDynamicHeaders(this.rows);
                this.catcount = Array(rs.detail.groupsNumber * 3).fill(0).map((x,i)=>i);

                this.rows.forEach(r => {
                    r.semaforo_var = this.getColor(r.porcenVariacionTotal);
                    r.sort_ventaTotal = parseFloat(r.ventaTotal.replace(/,/g, ''));
                    r.sort_ventaTotalAnterior = parseFloat(r.ventaTotalAnterior.replace(/,/g, ''));
                    r.sort_variacionTotal = parseFloat(r.variacionTotal.replace(/,/g, ''));
                    r.sort_porcenVariacionTotal = parseFloat(r.porcenVariacionTotal.replace(/,/g, ''));
                });
                
                this.cats.forEach(c => {
                	this.innercats.push('VTA NETA');
                	this.innercats.push('VTA PROM MES AÑO X-1');
                	this.innercats.push('$ VAR');
                });
            }
        });
    }

    getColor(par:any){
        var r:any;
        par = parseFloat(par.replace(/,/g, ''));
        r = {};

        if(par <= 0){
            //red
            r.color = '#ff0000';
            r.colorClass = 'orangered';
        }
        else if(par > 5){
            //green
            r.color = '#adff2f';
            r.colorClass = 'greenyellow';
        }
        else{
            //yellow
            r.color = '#ffff00';
            r.colorClass = 'yellow';
        }

        return r;
    }

    public getDynamicHeaders(rows:any){
    	var resp = [];

    	if( Array.isArray(rows) && (rows.length > 0) ){
    		rows.forEach(x => {
    			x.categories.forEach(c => {
    				let cat = c.nombreCategoria;
    				if( resp.indexOf(cat) < 0 ){
    					resp.push(cat);
    				}
    			});
    		});
    	}

    	return resp;
    }

    public getZonesData(){
        var par_url = 'ZoneBP/ListByUser';

        return this.srv.getCall(par_url).pipe(
                    mergeMap(data => {
                        let mydata:any = {status: false, data: [], message: ''};
                        mydata = data;
                        //console.log(data);
                        
                        if( mydata.status ){
                          return of(mydata.data);
                        }
                        else{
                          return of(false);
                        }
                      }),
                      //timeout(MAX_TIME),
                      catchError(data => {return of(false)})
                );
    }

    getPdfReportHeader(){
        var obj = [];

        obj.push([{content:'REPORTE VENTA ACUMULADA POR CLIENTE - CATEGORIA (VENDEDOR)', colSpan:4, styles:{fontStyle:'bold', halign:'center'}}]);
        obj.push([
            {content:'Vendedor: ' + this.header['agent'], colSpan:2},
            {content:'Fecha: ' + this.today, colSpan:2}
        ]);
        obj.push([
            {content:'Supervisor: ' + this.header['supervisor'], colSpan:2},
            {content:'Mes: ' + this.curr_date, colSpan:2}
        ]);

        return obj;
    }

    exportReport(){
        this.exportAsService.save(this.exportAsConfig, 'vta_cli_cat_'+this.curr_date).subscribe(() => {
          // save started
        });
    }

    addPagesHeaderAndFooter(doc:any) {
        var totalPages = doc.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            doc.addImage(Global.logo_base64, 'PNG', 710, 10, 90, 20);

            // Footer
            var str = 'Página ' + i + ' de ' + totalPages;
            doc.setFontSize(10);

            // jsPDF 1.4+ uses getWidth, <1.4 uses .width
            var pageSize = doc.internal.pageSize;
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
            doc.text(str, 40, pageHeight - 10);
        }

        return doc;
    }

}
